// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hpfilter-inputs .Select--single {
  min-width: 10em;
}
`, "",{"version":3,"sources":["webpack://./static/popups/timeseries/Reports.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB","sourcesContent":[".hpfilter-inputs .Select--single {\n  min-width: 10em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
